// extracted by mini-css-extract-plugin
export var container = "_nh-0";
export var dotAnimation = "_nh-2";
export var dotsLoading = "_nh-1";